import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce, useViewport } from '@chilecompra/react-kit'
import { DatePicker, Input, Typography } from '@chilecompra/react-kit/components'
import { RESOLUTION_LABELS, USER_TYPE } from '../../config/settings/constant'
import { onGetAttachmentsTypesThunk } from './Sanction.actions'
import TextArea from '../../components/Inputs/TextArea'
import { Column, Form, Row } from './SanctionDetailsForm.styles'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import useReCaptcha from '../../modules/hooks/reCaptcha'

/**
 * The Sanction Details Form's container.
 */
const SanctionDetailsForm = () => {
  const { userType } = useAuthorization()
  const { executeReCaptcha } = useReCaptcha()
  const dispatch = useDispatch()
  const {
    size: { isUpToMedium }
  } = useViewport()
  const {
    attachmentsTypes: { data: attachmentsTypes, loading },
    form: { attachmentType, backupDate, isSGC, reason, resolutionNumber, sanctionType },
    poBiddingInfo: { error: purchaseOrderError, loading: purchaseOrderLoading },
    userInfo: { error: userInfoError }
  } = useSelector(state => state.sanction)
  const { error: sellerError } = useSelector(state => state.basicSellerInformation)

  useEffectOnce(() => {
    if (!loading) return
    if (userType === USER_TYPE.PUBLIC) {
      const executeAll = async () => {
        await executeReCaptcha({ action: 'publicInfo' })
        dispatch(onGetAttachmentsTypesThunk())
      }
      executeAll()
    } else {
      const executeAll = () => {
        dispatch(onGetAttachmentsTypesThunk())
      }
      executeAll()
    }
  })

  return userInfoError || purchaseOrderError || purchaseOrderLoading || sellerError ? null : (
    <Row margin="0">
      <Column xs={12} sm={12} md={9} padding={isUpToMedium ? '0 27px 0 0' : '0'}>
        <Form>
          <Input disabled label="Tipo de sanción" maxWidth="320px" value={sanctionType} width="320px" />

          <TextArea
            disabled
            label="Motivo de sanción"
            maxCharactersForCounter={1500}
            maxLength={1500}
            rows={5}
            showCounter
            value={reason}
            width="100%"
          />

          {!isSGC && (
            <>
              <Typography fontWeight="bold" variant="h4">
                Acto administrativo que aplica sanción
              </Typography>

              <Row margin="0">
                <Column xs={6} sm={6} md={4} padding="0 5px 0 0">
                  <Input
                    disabled
                    label="Tipo de documento"
                    value={attachmentsTypes?.find(item => item.value === attachmentType)?.name}
                    width="100%"
                  />
                </Column>
                <Column xs={6} sm={6} md={4} padding={isUpToMedium ? '0 5px 0 0' : '0'}>
                  <Input
                    disabled
                    label={RESOLUTION_LABELS[attachmentType]}
                    maxCharactersForCounter={40}
                    maxLength={40}
                    showCounter
                    value={resolutionNumber}
                    width="100%"
                  />
                </Column>
                <Column xs={7} sm={6} md={4} padding="0">
                  <DatePicker
                    disabled
                    disableFuture
                    label="Fecha documento de respaldo"
                    value={backupDate}
                    width="100%"
                  />
                </Column>
              </Row>
            </>
          )}
        </Form>
      </Column>
    </Row>
  )
}

export default SanctionDetailsForm
